lg-accordion {
  display: block;
}
